module.exports = __webpack_public_path__ + "static/media/image-about-dark.fa292a67.jpg";